import React from 'react';
import {
    TableCell,
    TableHead,
    TableRow
} from 'material-ui';

const TableLanguagesHeader = ({classes, languages}) => (
    <TableHead>
        <TableRow>
            <TableCell className={classes.tableCell}>&nbsp;</TableCell>
            {languages.map(language =>
                <TableCell
                    className={classes.tableCellCenter}
                    key={language.id}>
                    {language.name}
                </TableCell>
            )}
        </TableRow>
    </TableHead>
);

export default TableLanguagesHeader;



// WEBPACK FOOTER //
// ./src/containers/configuration/forms/TableLanguagesHeader.jsx